import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMoneyFormatter } from '../../hooks/useMoneyFormatter';
export var MoneyView = function (_a) {
    var children = _a.children, sign = _a.sign, rule = _a.rule;
    var language = useTranslation('header').i18n.language;
    if (typeof (children === null || children === void 0 ? void 0 : children.value) !== 'number' || isNaN(children.value)) {
        return React.createElement(React.Fragment, null, "\u2014");
    }
    var formatted = useMoneyFormatter({ money: children, sign: sign, rule: rule, locale: language }).formatted;
    return React.createElement(React.Fragment, null,
        formatted,
        " ");
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/MoneyView/index.js
// module id = 725
// module chunks = 118